import React, { lazy } from 'react'

const CompanyPage = lazy(() => import('./CompanyPage'))

export { CompanyPage }
